import { render, staticRenderFns } from "./WorkFlowCreate.vue?vue&type=template&id=4bac20ec&scoped=true&"
import script from "./WorkFlowCreate.vue?vue&type=script&lang=js&"
export * from "./WorkFlowCreate.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowCreate.vue?vue&type=style&index=0&id=4bac20ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac20ec",
  null
  
)

export default component.exports